import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLogo } from '../rtk/slices/logo-slice';

const Footer = () => {
    const { t, i18n } = useTranslation();
    const date = new Date();
    const { logo } = useSelector((state) => state.logo);

    // Update document direction based on language
    useEffect(() => {
        const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.dir = direction;
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    return (
        <>
            {/* Footer */}
            <motion.footer
                initial={{ opacity: 1 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="bg-gradient-to-l from-[rgba(90,56,30,0.85)] to-[rgba(53,37,19,0.80)] text-white pt-6 sm:pt-8 pb-2 w-full max-w-full overflow-x-hidden"
            >
                <div className="w-full max-w-full px-3 sm:px-4 text-center">
                    <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
                        <div className="w-12 h-6 sm:w-20 sm:h-8 rounded-lg  flex items-center justify-center">
                            <img id='logo'
                                src={logo.length > 0 && `${process.env.REACT_APP_PROJECTS_API}assest/imgs/${logo[0].logo}`}
                                style={{ width: '7rem', borderRadius: '.5rem' }} alt="Company Logo" />
                        </div>
                        <span className="font-bold text-lg sm:text-xl">{t('hero.title')}</span>
                    </div>
                    <p className="text-gray-200 pt-3 text-sm sm:text-base px-2 break-words">
                        © {date.getFullYear()} {t('hero.title')}. {t('footer.allRightsReserved')} | {t('footer.craftingSince')}
                    </p>
                    Design By <a className='text-black font-bold' target='_blank' href="https://www.facebook.com/mohamedaraby.mando.01012648537">Mohamed Araby</a>
                </div>
            </motion.footer>
        </>
    )
}

export default Footer
